if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.variants = this.querySelectorAll('[data-product-variant]');
        this.initSlider();
      }
      connectedCallback() {
        this.variantChange();
      }

      get hidePriceOnFetch() {
        return this.hasAttribute('data-hide-price');
      }

      initSlider() {
        const sliderWrapper = this.querySelector('.product-card-slider');
        if (!sliderWrapper) return;
        const id = sliderWrapper.dataset?.productId;
        const sliderInstance = this.querySelector(`.swiper--${id}`);
        const btnNext = sliderInstance.querySelector('.slide--next');
        const btnPrev = sliderInstance.querySelector('.slide--prev');
        const scrollBar = sliderInstance.querySelector('.slider--scrollbar');
        const videos = this.querySelectorAll('video');
        const options = {
          slidePerView: 1,
          slidePerMove: 1,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: btnNext,
            prevEl: btnPrev,
          },
          scrollbar: {
            el: scrollBar,
            draggable: true,
            dragSize: 'auto',
          },
          on: {
            transitionStart: function () {
              if (videos.length === 0) return;
              this.videos.forEach((video) => {
                video.pause();
              });
            },
            transitionEnd: function () {
              const activeIndex = this.activeIndex;
              const activeSlide = this.slides[activeIndex];
              if (!activeSlide) return;
              const activeSlideVideo = activeSlide.querySelector('video');
              if (!activeSlideVideo) return;
              activeSlideVideo.play();
            },
          },
        };
        const slider = new Swiper(sliderInstance, options);
        if (window.innerWidth < 990) return;
        sliderWrapper.addEventListener('mouseenter', () => {
          if (slider.activeIndex >= 1) return;
          slider.slideTo(1, 300);
        });
        sliderWrapper.addEventListener('mouseleave', () => {
          if (slider.activeIndex === 0) return;
          slider.slideTo(0, 300);
        });
      }

      variantChange() {
        if (this.variants.length === 0) return;
        this.variants.forEach((variant) => {
          variant.addEventListener('click', async (event) => await this.handleVariantChange(event));
        });
      }

      async handleVariantChange(event) {
        event.preventDefault();
        const context = event.target?.dataset?.context;
        if (event.target.href.includes(this.dataset.url)) return;
        let view = 'card-collection';
        if (context === 'section') {
          view = 'card-section';
        }
        const variantUrl = event.target.href;
        this.dataset.url = variantUrl;
        let url = `${variantUrl}?view=${view}`;
        if (variantUrl.includes('?')) {
          url = `${variantUrl}&view=${view}`;
        }

        if (this.hidePriceOnFetch) {
          url = `${variantUrl.split('?')[0]}&view=${view}`;
        }

        const response = await fetch(url);
        if (!response.ok) return;

        const result = await response.text();
        const parser = new DOMParser().parseFromString(result, 'text/html');
        const newCard = parser.querySelector('product-card');
        if (!newCard) return;

        this.rerenderHTML(newCard);
        this.initSlider();
        this.setActiveVariant(newCard);
      }

      elementsToReplace() {
        return ['.product-card-slider', '.card-product-title', '.card-product-price', '.product-card-container'];
      }

      rerenderHTML(newCard) {
        this.elementsToReplace().forEach((element) => {
          const previousCardElement = this.querySelector(element);
          const newCardElement = newCard.querySelector(element);
          if (previousCardElement && newCardElement) {
            previousCardElement.outerHTML = newCardElement.outerHTML;
          }
        });
      }

      setActiveVariant(variantHTML) {
        const newActiveVariant = variantHTML.querySelector('.y1-color-swatch--current-color');
        if (!newActiveVariant) return;
        this.variants.forEach((variant) => variant.classList.remove('y1-color-swatch--current-color'));
        const activeVariantID = newActiveVariant.dataset.productVariant;
        if (!activeVariantID) return;
        const currentActiveVariant = this.querySelector(`[data-product-variant="${activeVariantID}"]`);
        currentActiveVariant.classList.add('y1-color-swatch--current-color');
      }
    }
  );
}
